// Editable fields from the supplied Lookup Controller contract.
const fields = [
    {
        "name": "stateId",
        "label": "State",
        "type": "lookup-select",
        "required": true,
        "source": "operational-states",
        "labelField": "stateName",
        "lockOnEdit": true
    },
    {
        "name": "stateName",
        "label": "State name",
        "type": "hidden",
        "required": false
    },
    {
        "name": "code",
        "label": "Code",
        "type": "text",
        "required": true
    },
    {
        "name": "aliases",
        "label": "Aliases",
        "type": "hidden",
        "required": false
    }
];

export default fields;
